import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#031f30" }, [
      _createElementVNode("path", { d: "M14.875 9.125H1.125a.625.625 0 0 1 0-1.25h13.75a.625.625 0 1 1 0 1.25M10.725 1.625a1.25 1.25 0 0 1 1.2.938l.031.118q.006.098 0 .194.007.097 0 .194l-.031.112a1.25 1.25 0 0 1-2.4 0V3.07a1 1 0 0 1 0-.194 2 2 0 0 1 0-.194v-.119a1.25 1.25 0 0 1 1.2-.937m0-1.25A2.5 2.5 0 0 0 8.313 2.25H1.125a.625.625 0 0 0 0 1.25h7.188a2.5 2.5 0 0 0 4.824 0h1.738a.625.625 0 1 0 0-1.25h-1.738A2.5 2.5 0 0 0 10.726.375M5.237 12.875a1.25 1.25 0 0 1 1.2.938l.032.118q.006.098 0 .194.008.098 0 .194l-.032.112a1.25 1.25 0 0 1-2.4 0v-.112a1 1 0 0 1 0-.194 2 2 0 0 1 0-.194v-.118a1.25 1.25 0 0 1 1.2-.938m0-1.25A2.5 2.5 0 0 0 2.825 13.5h-1.7a.625.625 0 1 0 0 1.25h1.7a2.5 2.5 0 0 0 4.825 0h7.225a.624.624 0 1 0 0-1.25H7.65a2.5 2.5 0 0 0-2.413-1.875m-2.5 2.5q0-.196.038-.387a3 3 0 0 0-.038.387" })
    ], -1)
  ]))]))
}
export default { render: render }